import type { JSONSchemaType } from "ajv";

import {
  meshSchema,
  pathSchema,
  positionSchema,
  vectorFieldSchema,
} from "./component-schemas";
import type { Entity } from "./types";

export const entitySchema: JSONSchemaType<Entity> = {
  type: "object",
  properties: {
    id: { type: "string" },
    position: { ...positionSchema, nullable: true },
    mesh: { ...meshSchema, nullable: true },
    path: { ...pathSchema, nullable: true },
    vectorField: { ...vectorFieldSchema, nullable: true },
  },
  required: ["id"],
  additionalProperties: false,
};
